import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Main_Img from '../../../assets/images/Speical_camp_img/Nasa_image.svg';
import User_sm_Img from '../../../assets/images/Speical_camp_img/Avatar.svg';
import defaultUser from '../../../assets/profile/default-profile-guardian.svg';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { GUARDIAN_SETTINGS_ROUTE } from '../../../constants/routes.constants';
import Date_calender from '../../../assets/images/Speical_camp_img/Date_calender.svg';
import Upcoming_Events_Time from '../../../assets/images/Speical_camp_img/Upcoming_Events.svg';
import { getSpecialCampDate } from '../../../utils/utils';
import ChallengeModal from '../../common/ChallengeModal';
import { specialCampViewModel } from './special.camp.viewmodel';
import { useAuth } from '../../auth/Auth';
import ConfirmAttendance from './ConfirmAttendance';
import {
  getKidSubscription,
  isCampFreeOrNot,
} from '../../../utils/subscription.util';
import SpecialCampButtons from './SpecialCampButtons';
import StarsIcon from '@mui/icons-material/Stars';

const CountdownTimer = ({ campTime }) => {
  const calculateTimeLeft = () => {
    const targetDate = new Date(campTime);
    const now = new Date();
    const difference = targetDate - now;

    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '10px',
        mb: 2,
        color: '#321B6D',
        fontSize: '16px',
        borderRadius: '15px',
      }}
      className="SPcampTimer"
    >
      <Box sx={{ textAlign: 'center' }} className="Timercontain">
        <Typography variant="h6">{timeLeft.days || '0'}</Typography>
        <Typography variant="body2">Day</Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }} className="Timercontain">
        <Typography variant="h6">{timeLeft.hours || '0'}</Typography>
        <Typography variant="body2">Hours</Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }} className="Timercontain">
        <Typography variant="h6">{timeLeft.minutes || '0'}</Typography>
        <Typography variant="body2">Minutes</Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }} className="Timercontain">
        <Typography variant="h6">{timeLeft.seconds || '0'}</Typography>
        <Typography variant="body2">Seconds</Typography>
      </Box>
    </Box>
  );
};

const SpecialCampCard = ({ camp, dependent, dependentSpecialCamps }) => {
  const history = useHistory();
  const { refreshUserState } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [selectedSpecialCamp, setSelectedSpecialCamp] = useState(null);
  const [isModalShow, setIsModalShow] = useState(false);
  const [chooseType, setChooseType] = useState('');
  const [attend, setAttend] = useState('PENDING');
  const [errorMessage, setErrorMessage] = useState('');
  const [targetDependent, setTargetDependent] = useState(dependent);
  const [isSpecialCampAttend, setIsSpecialCampAttend] = useState(false);

  const getSpecialCampTime = (time, timezone) => {
    const date = new Date(time);

    // Convert the date to the target timezone offset
    const options = { hour12: false, hour: '2-digit', minute: '2-digit' };
    const formatedTime = date
      .toLocaleTimeString('en-GB', options)
      .replace(':', 'h');

    return `${formatedTime} (${timezone})`;
  };

  const handleConfirm = (type) => {
    if (type === 'YES') {
      setConfirmText('Please confirm to attend this dream camp.');
      setChooseType('YES');
    } else {
      setConfirmText("Are you sure you don't want to attend this dream camp?");
      setChooseType('NO');
    }
    setShowConfirm(true);
  };

  const BuySpecialCamp = (camp) => {
    history.push({
      pathname: `${GUARDIAN_SETTINGS_ROUTE}/special-camp`,
      state: {
        specialCamp: camp,
        dependent: [dependent],
        purchased: 'purchase',
      },
    });
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
  };

  const handleAttend = () => {
    setAttend(chooseType);
    const dependent_id = dependent?.id;
    const special_camp_id = camp?.id;
    const params = {
      attend: chooseType === 'YES',
      dependent_id,
      special_camp_id,
    };
    specialCampViewModel
      .attend(params)
      .then((res) => {
        // console.log(res);
        setShowConfirm(false);
        setIsModalShow(res.response === 'YES');
        setAttend();
        setTargetDependent({
          ...targetDependent,
          special_camp: {
            ...targetDependent.special_camp,
            attend: chooseType,
          },
        });
        if (res.response === 'NO') {
          refreshUserState();
        }
      })
      .catch((err) => {
        setErrorMessage('');
      });
  };

  const setKidData = (kid) => {
    const tempKid = {
      profile: kid?.profile,
      subscription: kid?.subscriptions,
      school_details: kid.school_details,
    };
    return tempKid;
  };

  useEffect(() => {
    if (dependentSpecialCamps.length > 0) {
      // Check if camp.id exists in dependentSpecialCamps
      const isCampInSpecialCamps = dependentSpecialCamps.some(
        (specialCamp) => specialCamp.id === camp.id
      );
      setIsSpecialCampAttend(isCampInSpecialCamps);
    }
  }, [dependentSpecialCamps]);

  return (
    <React.Fragment>
      {isModalShow ? <ConfirmAttendance /> : ''}
      <ChallengeModal
        handleClose={handleConfirmClose}
        handleAction={handleAttend}
        show={showConfirm}
        type="confirm"
        level="warning"
        button1Label="Confirm"
        button2Label="Cancel"
      >
        <div>
          <span>{confirmText}</span>
        </div>
      </ChallengeModal>
      <Card
        sx={{
          maxWidth: 528,
          borderRadius: 3,
          boxShadow: 3,
          position: 'relative',
          margin: 'auto',
          mt: 2,
        }}
      >
        {/* Image and Badge */}
        <Box sx={{ position: 'relative' }}>
          {camp?.picture_url && (
            <CardMedia
              component="img"
              height="auto"
              image={camp?.picture_url}
              alt={camp?.name}
              sx={{ maxHeight: '250px' }}
            />
          )}
          {isCampFreeOrNot(camp, dependent) ? (
            <Chip
              label={`Included in ${getKidSubscription(
                setKidData(dependent)
              )} plan`}
              color="success"
              className={`card-chip ${getKidSubscription(
                setKidData(dependent)
              ).toLowerCase()}`}
            />
          ) : !!camp.special_camp_status ? (
            // <Chip
            //   label={`Accessed Premium Dream Camp`}
            //   color="success"
            //   className={`card-chip premium`}
            //   icon={
            //     <StarsIcon
            //       style={{
            //         background:
            //           'linear-gradient(180deg, #ffd700 0%, #ffc200 50%, #b8860b 100%)',
            //         borderRadius: 'inherit',
            //         color: 'green',
            //       }}
            //     />
            //   }
            // />
            ''
          ) : (
            <Chip label="$25" color="success" className={'card-chip paid'} />
          )}
        </Box>

        {/* Content */}
        <CardContent sx={{ textAlign: 'left' }}>
          <Typography variant="h4" gutterBottom className="SPcampHeader">
            Dream Camp: {camp?.name}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <CardMedia
              component="img"
              className="User_Img_avatar"
              image={
                camp?.created_by.picture_url
                  ? camp.created_by.picture_url
                  : defaultUser
              }
            />
            <Typography
              variant="div"
              color="text.secondary"
              sx={{
                mb: 2,
                ml: 3.2,
                color: '#321B6D',
                fontSize: '16px',
              }}
            >
              Meet the expert:{' '}
              <a
                href="javascript:void(0);"
                style={{ color: '#1E88E5', textDecoration: 'none' }}
              >
                {camp?.created_by?.first_name} {camp?.created_by?.last_name}
              </a>
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <CardMedia
              component="img"
              className="User_Img_date_time"
              image={Date_calender}
              width="20px"
            />
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mb: 2,
                ml: 3.2,
                color: '#321B6D',
                fontSize: '16px',
              }}
            >
              Date: <strong>{getSpecialCampDate(camp?.end_date_time)}</strong>
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <CardMedia
              component="img"
              className="User_Img_date_time"
              image={Upcoming_Events_Time}
              width="20px"
            />
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mb: 2,
                ml: 3.2,
                color: '#321B6D',
                fontSize: '16px',
              }}
            >
              Time:{' '}
              <strong>
                {getSpecialCampTime(camp?.end_date_time, camp?.timezone)}
              </strong>
            </Typography>
          </Box>
          {/* Countdown Timer */}
          <Box
            sx={{
              textAlign: 'left',
              justifyContent: 'flex-start',
              display: 'flex',
            }}
          >
            <CountdownTimer
              sx={{
                mb: 2,
                color: '#321B6D',
                fontSize: '16px',
              }}
              campTime={camp?.end_date_time}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mb: 2,
                color: '#321B6D',
                fontSize: '16px',
              }}
            >
              {camp?.description}
            </Typography>
          </Box>
        </CardContent>
      </Card>

      <SpecialCampButtons
        camp={camp}
        dependent={dependent}
        BuySpecialCamp={BuySpecialCamp}
        handleConfirm={handleConfirm}
        isSpecialCampAttend={isSpecialCampAttend}
      />
      <Divider
        sx={{
          maxWidth: '528px',
          margin: 'auto',
          marginTop: '40px',
          marginBottom: '40px',
        }}
      />
    </React.Fragment>
  );
};

export default SpecialCampCard;
